// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2FVQ3","col":"styles_col__2W2D2","actions":"styles_actions__25JFo","conflict":"styles_conflict__2yWY7"};